import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { inr } from "@/lib/format";
import { Package, ShoppingBag, AlertCircle, Wallet, TrendingUp, Users, Headphones, UserPlus } from "lucide-react";

export default function TenantDashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    api.get("/tenant/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/tenant/orders").then(({ data }) => setRecent(data.slice(0, 5))).catch(() => {});
  }, []);
  if (!stats) return <div className="p-8 text-slate-500">Loading...</div>;
  const cards = [
    { l: "Total Orders", v: stats.total_orders, c: "bg-blue-50 text-blue-700", i: ShoppingBag },
    { l: "Active Rentals", v: stats.active_orders, c: "bg-emerald-50 text-emerald-700", i: TrendingUp },
    { l: "Overdue", v: stats.overdue_orders, c: "bg-rose-50 text-rose-700", i: AlertCircle },
    { l: "Pending Payments", v: stats.pending_payments, c: "bg-amber-50 text-amber-700", i: AlertCircle },
    { l: "Revenue", v: inr(stats.revenue), c: "bg-violet-50 text-violet-700", i: TrendingUp },
    { l: "Deposit Held", v: inr(stats.deposit_held), c: "bg-cyan-50 text-cyan-700", i: Wallet },
    { l: "Products", v: stats.products_count, c: "bg-indigo-50 text-indigo-700", i: Package },
    { l: "Customers", v: stats.customers_count, c: "bg-pink-50 text-pink-700", i: Users },
    { l: "Open Tickets", v: stats.open_tickets, c: "bg-orange-50 text-orange-700", i: Headphones },
    { l: "New Leads", v: stats.new_leads, c: "bg-teal-50 text-teal-700", i: UserPlus },
  ];
  return (
    <div className="p-8">
      <h1 className="font-display text-3xl font-bold tracking-tight" data-testid="tenant-dashboard-title">Dashboard</h1>
      <p className="text-slate-500 text-sm mt-1 mb-6">Live overview of your rental business.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((c) => {
          const Icon = c.i;
          return (
            <Card key={c.l} className="p-4 border-slate-200" data-testid={`tenant-stat-${c.l.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className={`w-8 h-8 rounded-md grid place-items-center ${c.c}`}><Icon className="h-4 w-4" /></div>
              <div className="text-2xl font-display font-bold mt-3">{c.v}</div>
              <div className="text-xs text-slate-500 mt-1">{c.l}</div>
            </Card>
          );
        })}
      </div>
      <Card className="p-6 border-slate-200 mt-8">
        <h3 className="font-display font-semibold mb-4">Recent Orders</h3>
        {recent.length === 0 && <p className="text-sm text-slate-500">No orders yet.</p>}
        <div className="space-y-3">
          {recent.map((o) => (
            <div key={o.id} className="flex items-center justify-between text-sm border-b border-slate-100 pb-2 last:border-0" data-testid={`tenant-recent-order-${o.id}`}>
              <div>
                <div className="font-medium">{o.customer?.name || "—"} <span className="text-xs text-slate-500 font-mono">#{o.id.slice(0, 8)}</span></div>
                <div className="text-xs text-slate-500">{o.items?.length} item(s) • {o.status}</div>
              </div>
              <div className="text-right">
                <div className="font-semibold">{inr(o.total)}</div>
                <div className="text-xs text-slate-500">{o.payment_status}</div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
